<template>
  <header class="app-header" :class="{ 'is-scrolled': isScrolled }">
    <div class="header-container">
      <div class="logo">
        <span class="logo-text">TechStudio</span>
      </div>
      <nav class="nav-menu">
        <ul>
          <li><a href="#hero" class="nav-link">首页</a></li>
          <li><a href="#services" class="nav-link">服务</a></li>
          <li><a href="#portfolio" class="nav-link">作品</a></li>
          <li><a href="#about" class="nav-link">关于/联系</a></li>
        </ul>
      </nav>
      <div class="header-actions">
        <a href="#about" class="btn btn-primary">免费咨询</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isScrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 100;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;

  &.is-scrolled {
    height: 70px;
    background-color: rgba(255, 255, 255, 0.95);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-text {
  font-size: 24px;
  font-weight: 800;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  cursor: pointer;
}

.nav-menu {
  ul {
    display: flex;
    gap: 40px;
  }

  .nav-link {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-primary);
    position: relative;
    padding: 8px 0;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 3px;
      background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
      transition: all 0.3s ease;
      transform: translateX(-50%);
      border-radius: 2px;
    }

    &:hover {
      color: var(--primary-color);
      &::after {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
}
</style>
